import { render, staticRenderFns } from "./ManageTeam.vue?vue&type=template&id=34067b30&scoped=true&"
import script from "./ManageTeam.vue?vue&type=script&lang=ts&"
export * from "./ManageTeam.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTeam.vue?vue&type=style&index=0&id=34067b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34067b30",
  null
  
)

export default component.exports